import React from "react"
import types from "prop-types"
import { questionShape } from "utils/propTypeShapes"
import TextLinkDecorator from "components/shared/TextLinkDecorator"

const NoteAnswer = ({ question, isNewQuestion = false }) => {
  if (isNewQuestion) return null

  const { attributes: { note } } = question

  return (
    <div className="answer">
      <TextLinkDecorator value={note} className="formatted-note-contained" />
    </div>
  )
}

NoteAnswer.propTypes = {
  isNewQuestion: types.bool,
  question: questionShape.isRequired,
}

export default NoteAnswer
